export const CARD_WIDTH = 250;
